export const REFRESH_MS = 30000;

export const pick = (obj, camel, pascal, fallback = null) =>
  obj?.[camel] ?? obj?.[pascal] ?? fallback;

export const statusBannerColor = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "healthy") return "success.main";
  if (s === "warning") return "warning.main";
  return "error.main";
};

export const statusChipColor = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "healthy") return "success";
  if (s === "degraded" || s === "warning" || s === "stale") return "warning";
  if (s === "notconfigured" || s === "unknown") return "default";
  return "error";
};

export const severityChipColor = (severity) => {
  const s = (severity || "").toLowerCase();
  if (s === "critical") return "error";
  if (s === "warning") return "warning";
  return "info";
};

export const statusLabelFa = (status) => {
  const map = {
    healthy: "سالم",
    degraded: "نیاز به بررسی",
    unhealthy: "ناسالم",
    notconfigured: "پیکربندی نشده",
    unknown: "نامشخص",
    stale: "قدیمی",
    missing: "موجود نیست",
    critical: "بحرانی",
    warning: "هشدار",
  };
  return map[(status || "").toLowerCase()] || status || "—";
};

export const severityLabelFa = (severity) => {
  const map = { critical: "بحرانی", warning: "هشدار", info: "اطلاع" };
  return map[(severity || "").toLowerCase()] || severity || "—";
};

export const statSeverity = (value, { warn, critical }) => {
  if (critical != null && value >= critical) return "error";
  if (warn != null && value >= warn) return "warning";
  return "default";
};

export const formatPercent = (value, fallback = "—") => {
  if (value == null || Number.isNaN(Number(value))) return fallback;
  return `${Number(value).toLocaleString("fa-IR", { maximumFractionDigits: 1 })}٪`;
};

export const funnelConversion = (from, to) => {
  if (!from || from <= 0 || to == null) return "—";
  return formatPercent((to / from) * 100);
};

export const countHealthyComponents = (components) => {
  const list = components || [];
  const healthy = list.filter(
    (c) => (pick(c, "status", "Status") || "").toLowerCase() === "healthy"
  ).length;
  return { healthy, total: list.length };
};
